import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  cancel36mj9lv3a0whl as cancel,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
} from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { delayvyed5wvki0ic as delay } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import {
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  SubscriptionConnectionException12fjxvnnqzby5 as SubscriptionConnectionException,
  ApolloWebSocketClosedException26hvn543pf46i as ApolloWebSocketClosedException,
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock } from '../../../../../../../kotlinx-atomicfu/kotlinx/atomicfu/locks/Synchronized.mjs';
import { Dispatchers_getInstance20p7pyqnrepag as Dispatchers_getInstance } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import {
  plus20p0vtfmu0596 as plus,
  toList3jhuyej2anx2q as toList,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  ConnectionKeepAliveServerMessage_instance2ucdc3b7nis36 as ConnectionKeepAliveServerMessage_instance,
  PongServerMessage_instancegdhl9dh77vj7 as PongServerMessage_instance,
  PingServerMessage_instance2x2b9b7bh91v2 as PingServerMessage_instance,
  ParseErrorServerMessage28gxznaow3b26 as ParseErrorServerMessage,
  OperationErrorServerMessage3f3enfqsilvrv as OperationErrorServerMessage,
  CompleteServerMessage1c62v9ocjho2f as CompleteServerMessage,
  ResponseServerMessage1aifb0dqdz3sq as ResponseServerMessage,
  ConnectionErrorServerMessage21355wd69v8tf as ConnectionErrorServerMessage,
  ConnectionAckServerMessage_instance2uyrftb08sig4 as ConnectionAckServerMessage_instance,
} from '../ServerMessage.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { Duration5ynfiptaqcrg as Duration } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { decodeToString1x4faah2liw2p as decodeToString } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  DataClientMessage3splhk6u8gldd as DataClientMessage,
  TextClientMessage15942w7lyj1yt as TextClientMessage,
} from '../ClientMessage.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function restartIdleTimeout($this) {
  var tmp0_safe_receiver = $this.y67_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.nx();
  }
  var tmp = $this;
  tmp.y67_1 = launch($this.x67_1, VOID, VOID, SubscribableWebSocket$restartIdleTimeout$slambda($this));
}
function shutdownInternal($this, cause) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var listeners = ArrayList().p2();
  // Inline function 'kotlinx.atomicfu.locks.withLock' call
  $this.w67_1;
  if ($this.a68_1.equals(SocketState_ShutDown_getInstance())) {
    return Unit_instance;
  }
  $this.a68_1 = SocketState_ShutDown_getInstance();
  cancel($this.x67_1);
  $this.b68_1 = cause;
  listeners.u2($this.c68_1.z4());
  $this.c68_1.s4();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = listeners.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    element.o68(cause);
  }
}
function SubscribableWebSocket$restartIdleTimeout$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* delay(this$0.v67_1, $completion);
    this$0.t68(ApolloNetworkException().e47('WebSocket is idle'), 1001, 'Idle');
    return Unit_instance;
  }, 1);
}
function SubscribableWebSocket$onOpen$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    send(this$0.e68_1, yield* this$0.s67_1.o66($completion));
    return Unit_instance;
  }, 1);
}
function SubscribableWebSocket$onOpen$slambda_0(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* delay(this$0.u67_1, $completion);
    this$0.t68(ApolloNetworkException().e47('Timeout while waiting for connection_ack'), 1001, 'Timeout while waiting for connection_ack');
    return Unit_instance;
  }, 1);
}
function SubscribableWebSocket$onMessage$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    while (true) {
      yield* delay(this$0.t67_1, $completion);
      var tmp0_safe_receiver = this$0.s67_1.r66();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        send(this$0.e68_1, tmp0_safe_receiver);
      }
    }
    return Unit_instance;
  }, 1);
}
function SubscribableWebSocket$onMessage$slambda_0(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this$0.d68_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      send(this$0.e68_1, yield* this$0.s67_1.p66(element, $completion));
    }
    return Unit_instance;
  }, 1);
}
function SubscribableWebSocket$startOperation$slambda(this$0, $request) {
  return constructCallableReference(function *($this$launch, $completion) {
    send(this$0.e68_1, yield* this$0.s67_1.p66($request, $completion));
    return Unit_instance;
  }, 1);
}
function SubscribableWebSocket$stopOperation$slambda(this$0, $request) {
  return constructCallableReference(function *($this$launch, $completion) {
    send(this$0.e68_1, this$0.s67_1.q66($request));
    return Unit_instance;
  }, 1);
}
var SubscribableWebSocketClass;
function SubscribableWebSocket() {
  if (SubscribableWebSocketClass === VOID) {
    class $ {
      constructor(webSocketEngine, serverUrl, httpHeaders, wsProtocol, pingInterval, connectionAcknowledgeTimeout, idleTimeout) {
        this.s67_1 = wsProtocol;
        this.t67_1 = pingInterval;
        this.u67_1 = connectionAcknowledgeTimeout;
        this.v67_1 = idleTimeout;
        var tmp = this;
        // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
        tmp.w67_1 = get_atomicfu$reentrantLock();
        this.x67_1 = CoroutineScope(Dispatchers_getInstance().h13_1);
        this.y67_1 = null;
        this.z67_1 = null;
        this.a68_1 = SocketState_AwaitOpen_getInstance();
        this.b68_1 = null;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.c68_1 = LinkedHashMap().ec();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_1.d68_1 = ArrayList().p2();
        var tmp_2;
        var tmp$ret$3;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_3;
          if (isInterface(httpHeaders, Collection())) {
            tmp_3 = httpHeaders.n1();
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            tmp$ret$3 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = httpHeaders.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            if (element.x48_1.toLowerCase() === 'sec-websocket-protocol') {
              tmp$ret$3 = true;
              break $l$block_0;
            }
          }
          tmp$ret$3 = false;
        }
        if (tmp$ret$3) {
          tmp_2 = httpHeaders;
        } else {
          tmp_2 = plus(httpHeaders, new (HttpHeader())('Sec-WebSocket-Protocol', this.s67_1.h1()));
        }
        var headers = tmp_2;
        var listener = new (BufferedWebSocketListener())();
        this.e68_1 = webSocketEngine.u68(serverUrl, headers, listener);
        listener.y68(this);
      }
      z68(markActive) {
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.w67_1;
        // Inline function 'kotlin.also' call
        var this_0 = this.a68_1.equals(SocketState_ShutDown_getInstance());
        if (!this_0 && markActive) {
          var tmp0_safe_receiver = this.y67_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.nx();
          }
          this.y67_1 = null;
        }
        return this_0;
      }
      t68(cause, code, reason) {
        shutdownInternal(this, cause);
        this.e68_1.a69(code, reason);
      }
      b69() {
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.w67_1;
        if (this.a68_1.w1_1 === 0) {
          launch(this.x67_1, VOID, VOID, SubscribableWebSocket$onOpen$slambda(this));
          var tmp = this;
          tmp.z67_1 = launch(this.x67_1, VOID, VOID, SubscribableWebSocket$onOpen$slambda_0(this));
          this.a68_1 = SocketState_AwaitAck_getInstance();
        }
      }
      c69(text) {
        var message = this.s67_1.t66(text);
        if (equals(message, ConnectionAckServerMessage_instance)) {
          var tmp0_safe_receiver = this.z67_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.nx();
          }
          this.z67_1 = null;
          // Inline function 'kotlinx.atomicfu.locks.withLock' call
          this.w67_1;
          if (!this.a68_1.equals(SocketState_AwaitAck_getInstance())) {
            return Unit_instance;
          }
          this.a68_1 = SocketState_Connected_getInstance();
          var tmp = this.t67_1;
          if (!((tmp == null ? null : new (Duration())(tmp)) == null)) {
            launch(this.x67_1, VOID, VOID, SubscribableWebSocket$onMessage$slambda(this));
          }
          launch(this.x67_1, VOID, VOID, SubscribableWebSocket$onMessage$slambda_0(this));
        } else {
          if (message instanceof ConnectionErrorServerMessage()) {
            this.t68(SubscriptionConnectionException().w4e(message.d69_1), 1001, 'Connection error');
          } else {
            if (message instanceof ResponseServerMessage()) {
              // Inline function 'kotlinx.atomicfu.locks.withLock' call
              this.w67_1;
              var tmp1_safe_receiver = this.c68_1.x4(message.u66_1);
              if (tmp1_safe_receiver == null)
                null;
              else {
                tmp1_safe_receiver.k68(message.v66_1);
              }
            } else {
              if (message instanceof CompleteServerMessage()) {
                // Inline function 'kotlinx.atomicfu.locks.withLock' call
                this.w67_1;
                var tmp2_safe_receiver = this.c68_1.x4(message.w66_1);
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  tmp2_safe_receiver.m68();
                }
              } else {
                if (message instanceof OperationErrorServerMessage()) {
                  // Inline function 'kotlinx.atomicfu.locks.withLock' call
                  this.w67_1;
                  var tmp3_safe_receiver = this.c68_1.x4(message.x66_1);
                  if (tmp3_safe_receiver == null)
                    null;
                  else {
                    tmp3_safe_receiver.n68(message.y66_1);
                  }
                } else {
                  if (message instanceof ParseErrorServerMessage()) {
                    println("Cannot parse message: '" + message.z66_1 + "'");
                  } else {
                    if (equals(message, PingServerMessage_instance)) {
                      var tmp4_safe_receiver = this.s67_1.s66();
                      if (tmp4_safe_receiver == null)
                        null;
                      else {
                        // Inline function 'kotlin.let' call
                        send(this.e68_1, tmp4_safe_receiver);
                      }
                    } else {
                      if (!equals(message, PongServerMessage_instance)) {
                        if (!equals(message, ConnectionKeepAliveServerMessage_instance)) {
                          noWhenBranchMatchedException();
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      e69(data) {
        this.c69(decodeToString(data));
      }
      f69(cause) {
        shutdownInternal(this, cause);
      }
      g69(code, reason) {
        shutdownInternal(this, ApolloWebSocketClosedException().w4d(code == null ? 1001 : code, reason));
      }
      f68(request, listener) {
        var cause = null;
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.w67_1;
        var tmp0_safe_receiver = this.y67_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.nx();
        }
        this.y67_1 = null;
        var tmp;
        switch (this.a68_1.w1_1) {
          case 0:
          case 1:
            this.c68_1.a5(request.u40_1.toString(), listener);
            tmp = this.d68_1.j2(request);
            break;
          case 2:
            this.c68_1.a5(request.u40_1.toString(), listener);
            tmp = launch(this.x67_1, VOID, VOID, SubscribableWebSocket$startOperation$slambda(this, request));
            break;
          case 3:
            cause = DefaultApolloException().q42('Apollo: the WebSocket is shut down', this.b68_1);
            tmp = Unit_instance;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        if (!(cause == null)) {
          listener.o68(ensureNotNull(cause));
        }
      }
      g68(request) {
        var id = request.u40_1.toString();
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.w67_1;
        if (this.c68_1.v4(id)) {
          this.c68_1.b5(id);
          launch(this.x67_1, VOID, VOID, SubscribableWebSocket$stopOperation$slambda(this, request));
          if (this.c68_1.n1()) {
            restartIdleTimeout(this);
          }
        }
      }
    }
    initMetadataForClass($, 'SubscribableWebSocket');
    SubscribableWebSocketClass = $;
  }
  return SubscribableWebSocketClass;
}
var SocketState_AwaitOpen_instance;
var SocketState_AwaitAck_instance;
var SocketState_Connected_instance;
var SocketState_ShutDown_instance;
var SocketState_entriesInitialized;
function SocketState_initEntries() {
  if (SocketState_entriesInitialized)
    return Unit_instance;
  SocketState_entriesInitialized = true;
  SocketState_AwaitOpen_instance = new (SocketState())('AwaitOpen', 0);
  SocketState_AwaitAck_instance = new (SocketState())('AwaitAck', 1);
  SocketState_Connected_instance = new (SocketState())('Connected', 2);
  SocketState_ShutDown_instance = new (SocketState())('ShutDown', 3);
}
var SocketStateClass;
function SocketState() {
  if (SocketStateClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'SocketState');
    SocketStateClass = $;
  }
  return SocketStateClass;
}
function dispatch($this, callback) {
  // Inline function 'kotlinx.atomicfu.locks.withLock' call
  $this.v68_1;
  // Inline function 'kotlin.also' call
  var this_0 = $this.w68_1;
  if (this_0 == null) {
    $this.x68_1.j2(callback);
  }
  var target = this_0;
  if (!(target == null)) {
    callback(target);
  }
}
function BufferedWebSocketListener$onOpen$lambda(it) {
  it.b69();
  return Unit_instance;
}
var BufferedWebSocketListenerClass;
function BufferedWebSocketListener() {
  if (BufferedWebSocketListenerClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
        tmp.v68_1 = get_atomicfu$reentrantLock();
        this.w68_1 = null;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.x68_1 = ArrayList().p2();
      }
      y68(target) {
        while (true) {
          // Inline function 'kotlinx.atomicfu.locks.withLock' call
          this.v68_1;
          if (this.x68_1.n1()) {
            this.w68_1 = target;
            return Unit_instance;
          }
          // Inline function 'kotlin.also' call
          var this_0 = toList(this.x68_1);
          this.x68_1.s4();
          var callbacks = this_0;
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = callbacks.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            element(target);
          }
        }
      }
      b69() {
        return dispatch(this, BufferedWebSocketListener$onOpen$lambda);
      }
      c69(text) {
        return dispatch(this, (it) => {
          it.c69(text);
          return Unit_instance;
        });
      }
      e69(data) {
        return dispatch(this, (it) => {
          it.e69(data);
          return Unit_instance;
        });
      }
      f69(cause) {
        return dispatch(this, (it) => {
          it.f69(cause);
          return Unit_instance;
        });
      }
      g69(code, reason) {
        return dispatch(this, (it) => {
          it.g69(code, reason);
          return Unit_instance;
        });
      }
    }
    initMetadataForClass($, 'BufferedWebSocketListener', BufferedWebSocketListener);
    BufferedWebSocketListenerClass = $;
  }
  return BufferedWebSocketListenerClass;
}
function send(_this__u8e3s4, clientMessage) {
  if (clientMessage instanceof TextClientMessage()) {
    _this__u8e3s4.j69(clientMessage.l66_1);
  } else {
    if (clientMessage instanceof DataClientMessage()) {
      _this__u8e3s4.i69(clientMessage.h69_1);
    } else {
      noWhenBranchMatchedException();
    }
  }
}
function SocketState_AwaitOpen_getInstance() {
  SocketState_initEntries();
  return SocketState_AwaitOpen_instance;
}
function SocketState_AwaitAck_getInstance() {
  SocketState_initEntries();
  return SocketState_AwaitAck_instance;
}
function SocketState_Connected_getInstance() {
  SocketState_initEntries();
  return SocketState_Connected_instance;
}
function SocketState_ShutDown_getInstance() {
  SocketState_initEntries();
  return SocketState_ShutDown_instance;
}
//region block: exports
export {
  SubscribableWebSocket as SubscribableWebSockethkxzhdarcovi,
};
//endregion

//# sourceMappingURL=SubscribableWebSocket.mjs.map
